<template>
    <div class="proCases" ref="elementsList">

            <div class="fsTitle listTitle">
                {{itemsTitle}}
            </div>                
            <!-- <div style="color:#000;">{{panelsData}}</div><br/><br/> -->

            <div class="casePanel" v-for="(item,index) in itemsData" :key="'cc_'+item.id">
                
                <i class="pnlToggler fal fa-plus"></i>
                
                <div class="casePanelContent">
                    <div class="cpTitle" @click="togglePnl(index)">                    
                        <span>{{item.title}}</span>
                    </div>
                    <div class="cpContent" style="height:0px">
                        <div class="cpInner">
                            <!-- this div will define the height -->
                            <span class="cpiTitle">{{item.sub_title}}</span>
                            <span class="cpiSum">{{item.summary}}</span>
                            
                            <!-- buttons -->
                            <div class="cpiButtons" v-if="item.children && item.children.length">
                                <div class="cpiBtn" v-for="(publication,index) in item.children" :key="'media_'+publication.id">
                                    <abtn
                                        :url="publication.url"
                                        :class="['mt-xl']"
                                        color="blue">
                                        <span v-text="publication.title"></span>
                                    </abtn>                                
                                    <!-- {{publication.title}}{{publication.url}} -->

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

          <ul style="display:none;">      
            <li v-for="(item,index) in itemsData" :key="'cc_'+item.id">



                {{item.title}}
                <br/><br/>
                {{item.sub_title}}
                <br/><br/>
                {{item.summary}}
                <h3>Media items:</h3>
                <div v-for="(mediaItem,index) in item.children" :key="'media_'+mediaItem.id">
                  {{mediaItem.title}}
                  <br/>
                  {{mediaItem.url}}
                </div>
                <br/><br/>
                <br/><br/>
            </li>
          </ul>        
    </div>
</template>


<script>
import { mapActions, mapState } from "vuex";

export default {
    components:{},
    props: 
    {
        itemsTitle:String,
        itemsData:Object        
    },
    data()
    {
        return {
            panelsData:[],
            selectedIndex:0
        }
    },
    mounted() {
        //collect height and status for each panel
        var listElement = this.$refs.elementsList;

        var panlsList = listElement.querySelectorAll('.casePanel');
        for (var i=0; i < panlsList.length; i++) 
        {
            let _pnl = panlsList[i];
            let _pnlToggler = _pnl.querySelectorAll('.pnlToggler')[0];
            let _cpContent = _pnl.querySelectorAll('.cpContent')[0];//this height will be changed
            let _cpInner = _pnl.querySelectorAll('.cpInner')[0];//this will define the height
            let _elData = 
            {
                height:_cpInner.offsetHeight,
                expended:false,
                cpContent:_cpContent,
                pnlToggler:_pnlToggler
            }
            this.panelsData.push(_elData);
        }

    },
    destroyed() {

    },
    methods:
    {
        togglePnl(index)
        {
            var pnlItemData = this.panelsData[index];
            var newH = 0;


            if(pnlItemData.expended==false){
                newH = pnlItemData.height;
                pnlItemData.pnlToggler.className = "pnlToggler fal fa-minus";     
            }else{
                pnlItemData.pnlToggler.className = "pnlToggler fal fa-plus";                
            }
            pnlItemData.expended = !pnlItemData.expended;
            pnlItemData.cpContent.style.height = newH +"px";
        },
        getVideoUrl()
        {
            //return this.sectionData.video_path;//  "img/video/MIS_Lance_plus_Con_KIT2.mp4";
        }
    },
    computed:{
        //...mapState(["minisite_data"]),
        //sectionData(){ 
            //return this.minisite_data.SECTIONS[this.sectionDataIndex];
        //}

    }
};
</script>

<style>
    .listTitle
    {
        font-size: 30px;
        letter-spacing: -1px !important;       
        font-weight: 300 !important;
        padding-bottom: 20px;
        color: #0976bd !important;
    }
    .proCases
    {
        padding-bottom: 50px;
    }
    .casePanel
    {
        padding: 20px 0px;
        border-bottom: solid 1px #0976bd;
        text-align: left;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        overflow: hidden;        
    }
    .casePanelContent
    {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        max-width: 90%;        
    }
    .pnlToggler
    {        
        font-size: 22px;
        color: #0976bd !important;
        margin-right: 15px;
        margin-top: 3px;
    }

    .cpTitle span
    {
        display: inline-block;
        color: #202020;
        font-size: 20px;
        font-weight: 300 !important;
        cursor: pointer;
    }
    .casePanel:hover .cpTitle span
    {
        color: #0976bd;
    }


    .cpContent 
    {
        font-size: 14px;
        color: #000;
        transition: all ease 0.8s;
        overflow: hidden;
    }
    .cpiTitle
    {
        padding-top: 20px;
        display: block;
        font-weight: 300 !important;
    }
    .cpiSum
    {
        padding-top: 10px;
        display: block;
    }
    .cpiButtons
    {
        padding-bottom: 20px;
        clear: both;
    }
    .cpiBtn
    {
        padding-right: 20px;
        display: inline-block;
    }

  @media (hover: hover) {
  }

  @media (max-width: 850px) {     
  }  
</style>


